import { cn } from '@sohanemon/utils';
import { usePerformant } from '@sohanscript/lib/hooks/performant';
import { CursorTracker } from '@sohanscript/ui/cursor-tracker';
import { Spotlight } from '@sohanscript/ui/spotlight';
import type { ComponentProps } from 'react';
import {
	ProjectGridItem,
	type ProjectGridItemProps,
} from './project-grid-item';

type ProjectListProps = ComponentProps<'div'> & {
	projects: ProjectGridItemProps[];
};

export function ProjectList({
	className,
	projects,
	...props
}: ProjectListProps) {
	const performant = usePerformant();
	return (
		<div
			className={cn(
				'grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-5 lg:gap-8',
				className,
			)}
			{...props}
		>
			{projects?.map((project, idx) => (
				<Spotlight
					key={project.slug?.current}
					className={cn(
						(Math.floor(idx / 2) % 2 === 0 && idx % 2 === 0) ||
							(Math.floor(idx / 2) % 2 === 1 && idx % 2 === 1)
							? 'lg:col-span-3'
							: 'lg:col-span-2',
					)}
				>
					{performant ? (
						<CursorTracker>
							<ProjectGridItem
								className="w-full max-w-full cursor-none"
								{...project}
								initial="hidden"
							/>
						</CursorTracker>
					) : (
						<ProjectGridItem
							className="w-full max-w-full"
							{...project}
							initial="hidden"
						/>
					)}
				</Spotlight>
			))}
		</div>
	);
}
